module.exports = "/assets/data/4dbd23a00a8aaf1eba497615afd49c36-HS3.data.json";